import React from 'react';
import { useAppSelector } from '../../redux/hook';

interface ComponentLoadingBarProps {
    isLoading?: boolean;
}
const ComponentLoadingBar: React.FC<ComponentLoadingBarProps> = ({
    isLoading = false
}) => {
    // If we're loading at a global level, don't show this component-level loading bar
    const promptType = useAppSelector(state=>state.fullScreenPrompt.promptType)
    const isActive = useAppSelector(state=>state.fullScreenPrompt.isActive)

    if (!isLoading || (isActive && promptType === "loading")) {
        return null;
    }

    return (
        <div className="flex flex-col items-center justify-center z-10">             
            <div className="relative w-12 h-12">
                {[...Array(6)].map((_, i) => (
                    <div
                        key={i}
                        className="absolute w-2 h-2 bg-ui-electricGreen/60 rounded-full"
                        style={{
                            left: '50%',
                            top: '50%',
                            transformOrigin: '-8px 8px',
                            transform: `translate(-50%, -50%) rotate(${i * 60}deg)`,
                            animation: `hexFade 1.2s ease-in-out infinite`,
                            animationDelay: `${i * 0.2}s`
                        }}
                    />
                ))}
            </div>
            <style>{`
                @keyframes hexFade {
                    0%, 80%, 100% { opacity: 0.2; }
                    40% { opacity: 1; }
                }
            `}</style>
        </div>
    );
};

export default ComponentLoadingBar;